<template>
  <div>
    <component
      :is="currentComponent"
      :project="project"
      @donate="handleShownForm"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import { getURLParams } from 'lib/utils/payment-url';

import CatalogBills from 'organisms/catalogs/CatalogBills';
import PaymentAmount from '@/pages/project/PaymentAmount';

const COMPONENT_CATALOG = 'catalog';
const COMPONENT_FORM = 'form';

const COMPONENTS_MAP = {
  [COMPONENT_CATALOG]: 'CatalogBills',
  [COMPONENT_FORM]: 'PaymentAmount',
};

export default {
  name: 'PersonalPayment',
  components: {
    CatalogBills,
    PaymentAmount,
  },
  created() {
    this.initialize();
  },
  computed: {
    projectCode() {
      return this.$route.params.projectCode;
    },
    currentComponent() {
      const component = this.project.hasMarketplaceBills && this.$validate.isEmptyObject(getURLParams())
        ? COMPONENT_CATALOG : COMPONENT_FORM;

      return COMPONENTS_MAP[component];
    },
    ...mapState('project', ['project']),
    ...mapGetters('project', ['isInactiveProject']),
  },
  methods: {
    async initialize() {
      try {
        await this.loadProject(this.projectCode);

        if (this.isInactiveProject) {
          this.$router.push({ name: 'project.blocked' });
          return;
        }
      } catch (error) {
        this.$router.push({ name: 'service.error' });
      }
    },
    handleShownForm() {
      this.project.hasMarketplaceBills = false;
    },
    ...mapActions('project', ['loadProject']),
  },
};
</script>
